import { ft } from '../../../../lib/utils.js';

const add = ft('i18n_common_add', '添加');
const checked = ft('i18n_common_checked', '选中');
const description = ft('i18n_common_description', '描述');
const factory = ft('i18n_common_factory', '工厂');
const materialDescription = ft('i18n_common_material_description', '物料描述');
const materialName = ft('i18n_common_material_name', '物料名称');
const materialNumber = ft('i18n_common_material_number', '物料编码');
const numberOfVouchers = ft('i18n_common_number_of_vouchers', '凭证数量');
const name = ft('i18n_common_name', '名称');
const noData = ft('i18n_common_no_data', '暂无数据');
const orderLineNumber = ft('i18n_common_order_line_number', '订单行号');
const orderNumber = ft('i18n_common_order_number', '订单编号');
const orderQuantity = ft('i18n_common_order_quantity', '订单数量');
const personName = ft('i18n_common_person_name', '姓名');
const pleaseEnter = ft('i18n_common_please_enter', '请输入 ');
const serialNumber = ft('i18n_common_serial_number', '序号');
const save = ft('i18n_common_save', '保存 ');
const saleContract = ft('i18n_common_sales_contract_no', '销售合同号');
const specifications = ft('i18n_common_specifications', '规格');
const state = ft('i18n_common_state', '状态');
const subAccount = ft('i18n_common_sub_account', '子账号');
const supplierAccount = ft('i18n_common_supplier_account', '供应商账号');
const supplierName = ft('i18n_common_supplier_name', '供应商名称');
const units = ft('i18n_common_units', '单位');

export const COMPANY = {
  companyCode: ft('i18n_common_company_code', '公司编码'),
  companyName: ft('i18n_common_company_name', '公司名称'),
  serialNumber
};

export const COST_CENTER = {
  costCenterCode: ft('i18n_common_cost_center_code', '成本中心编码'),
  email: ft('i18n_common_email', '电子邮件'),
  name,
  phoneNumber: ft('i18n_common_phone_number', '电话号码'),
  serialNumber
};

// 部门
export const DEPARTMENT = {
  departmentCode: ft('i18n_common_department_code', '部门编码'),
  description,
  serialNumber
};

// 送货通知单
export const DELIVER = {
  deliveryNoteLineNumber: ft('i18n_common_delivery_note_line_number', '送货通知单行号'),
  deliveryNoteNumber: ft('i18n_common_delivery_note_number', '送货通知单号'),
  materialDescription,
  materialNumber,
  numberOfVouchers,
  orderNumber,
  orderLineNumber,
  remainingAmount: ft('i18n_common_the_remaining_amount', '剩余数量'),
  sendQuantity: ft('i18n_common_send_quantity', '发送数量'),
  serialNumber
};

// 工厂
export const FACTORY = {
  factoryCode: ft('i18n_common_factory_code', '工厂编码'),
  description,
  serialNumber
};

// 阶梯
export const LADDER = {
  noData,
  numberOfSteps: ft('i18n_common_the_number_of_steps', '阶梯数量'),
  pleaseEnter,
  ladderStep: ft('i18n_common_ladder_step', '阶梯级')
};

// 阶梯 form
export const LADDER_FORM = {
  add,
  numberOfSteps: LADDER.numberOfSteps,
  pleaseEnter,
  numberGreater: ft('i18n_common_number_greater', '大于 ? 的数字')
};

// 物料
export const MATERIALS = {
  factory,
  materialDescription,
  materialName,
  materialNumber,
  serialNumber,
  specifications,
  units
};

// 物料组
export const MATERIAL_GROUP = {
  description,
  materialGroupCode: ft('i18n_common_material_group_code', '物料组编码'),
  serialNumber
};

export const MATERIALS_DIALOG = {
  factory,
  materialDescription,
  materialName,
  materialNumber,
  quantity: ft('i18n_common_quantity', '数量'),
  save,
  specifications,
  units
};

export const MATERIALS_SELECT = {
  ...MATERIALS_DIALOG,
  checked,
  serialNumber
};

// 订单
export const ORDER = {
  deliveryDate: ft('i18n_common_delivery_date', '交货日期'),
  factory: ft('i18n_common_factory', '工厂'),
  materialName,
  materialNumber,
  materialSpecifications: ft('i18n_common_material_specifications', '物料规格'),
  orderNumber,
  orderLineNumber,
  orderQuantity,
  quantityOfDeliveryNoticesSent: ft(
    'i18n_common_quantity_of_delivery_notices_sent',
    '已发送货通知单数量'
  ),
  receiver: ft('i18n_common_receiver', '收货人'),
  requestForPurchaseRemaks: ft('i18n_common_request_for_rurchase_remarks', '请购备注'),
  saleContract,
  serialNumber,
  productOrderNo: ft('i18n_common_product_order_no', '生产订单料号'),
  plateLengthModel: ft('i18n_common_plate_length_model', '板长型号'),
  voucherNumber: ft('i18n_common_voucher_number', '送货单号')
};

// 组织
export const ORGANIZATION = {
  organizationCode: ft('i18n_common_organization_code', '组织编码'),
  description,
  serialNumber
};

// 价格历史信息
export const PRICE_RECORD = {
  materialNumber,
  materialName,
  priceInformationNumber: ft('i18n_common_price_information_number', '价格信息编号'),
  supplier: ft('i18n_common_supplier', '供应商'),
  serialNumber
};

// 采购组
export const PURCHASING_GROUP = {
  description,
  purchasingGroupCode: ft('i18n_common_purchasing_group_code', '采购组编码'),
  serialNumber
};

// 采购组织
export const PURCHASING_ORGANIZATION = {
  purchasingOrganizationCode: ft('i18n_common_purchasing_organization_code', '采购组织编码'),
  description,
  serialNumber
};

// 对账单
export const RECONCILIATION = {
  materialName,
  materialNumber,
  numberOfInvoicesAvailable: ft('i18n_common_number_of_invoices_available', '可开票数量'),
  numberOfInvoicesIssued: ft('i18n_common_number_of_invoices_issued', '已开票数量'),
  orderQuantity,
  orderNumber,
  priceIncludeTax: ft('i18n_common_price_including_tax', '含税价'),
  reconciliationQuantity: ft('i18n_common_reconciliation_quantity', '对账数量'),
  serialNumber,
  statementNumber: ft('i18n_common_statement_number', '对账单号'),
  taxCode: ft('i18n_common_tax_code', '税码')
};

// 子账号: 收货人, 采购计划员, 采购负责人
export const SUBACCOUNT = {
  personName,
  subAccount,
  serialNumber
};

// 供应商
export const SUPPLIERS = {
  serialNumber,
  supplierAccount,
  supplierName
};

// 供应商对话框
export const SUPPLIER_SELECT = {
  ...SUPPLIERS,
  noData,
  purchasingOrganization: ft('i18n_common_purchasing_organization', '采购组织'),
  state
};

// 供应商(子账号)对话框
export const SUPPLIER_SUBACCOUNT = {
  ...SUPPLIER_SELECT,
  checked,
  noData,
  subAccount,
  personName
};

// 收货单
export const VOUCHER = {
  numberOfVouchers,
  orderLineNumber,
  orderNumber,
  orderQuantity,
  receiptVoucherNumber: ft('i18n_common_receipt_goods_voucher_number', '收货凭证号'),
  serialNumber,
  voucherLineNumber: ft('i18n_common_voucher_line_number', '凭证行号')
};
